import { useSessionStorageState } from "ahooks"
import { useCallback } from "react"

export function useSpotlight(globalDelay = 3000) {
	const [state, setState] = useSessionStorageState<Spotlight[]>("spotlights", {
		listenStorageChange: true,
		defaultValue: [],
	})
	const focus = useCallback(
		(key: Spotlight["key"], delay = globalDelay) => {
			setState((prev = []) => [...prev, { key, delay }])

			setTimeout(
				() => setState((prev = []) => prev.filter((spot) => spot.key !== key)),
				delay,
			)
		},
		[globalDelay, setState],
	)
	const isFocused = useCallback(
		(key: Spotlight["key"]) => state.some((h) => h.key === key),
		[state],
	)

	return { isFocused, focus }
}

interface Spotlight {
	key: "all-visits-tab" | "needs-scheduling-tab" | `visit-${string}`
	delay?: number
}
